import { GaEventsProps } from '@/store/types/IBuilder';
import { getDataAttributes } from '@/utils/dataAttributes';
import { trackEvent } from '@/utils/gaDataPush';
import beTwMerge from '@/utils/beTwMerge';
import colors from '@/styles/colors';

interface ISlimlineBannerProps {
  desktopText: string | HTMLElement;
  mobileText: string | HTMLElement;
  link: string;
  iconRight: string;
  iconLeft: string;
  backgroundHexColor: string;
  textHexColor: string;
  gaEvents?: GaEventsProps[];
  iconRightAlt?: string;
  iconLeftAlt?: string;
}

export default function SlimlineBanner({
  desktopText,
  mobileText,
  link,
  iconRight,
  iconLeft,
  backgroundHexColor,
  textHexColor,
  gaEvents,
  iconRightAlt,
  iconLeftAlt,
}: ISlimlineBannerProps) {
  return link ? (
    <a
      className={beTwMerge(
        'tw-flex tw-justify-center tw-items-center tw-cursor-pointer hover:tw-no-underline tw-mb-0 tw-group tw-min-h-[39px] lg:tw-min-h-[32px]'
      )}
      style={{ backgroundColor: backgroundHexColor || colors['dark-green'].raw }}
      href={link}
      {...getDataAttributes({ gaEvents })}
      onClick={trackEvent}
    >
      {iconLeft && (
        <div className="tw-m-0 tw-mr-2" style={{ color: textHexColor || 'white' }}>
          <img className="tw-max-w-full t-max-h-full !tw-w-5 md:!tw-w-6" src={iconLeft} alt={iconLeftAlt || ''} />
        </div>
      )}

      {desktopText && (
        <div
          className={beTwMerge(
            'tw-py-[5px] tw-flex tw-items-center [&>*]:tw-m-0 t-h-full tw tw-text-center tw-font-nav-link tw-font-normal tw-text-be-2xs lg:tw-text-be-s group-hover:tw-no-underline lg:tw-text-base !hover:tw-no-underline tw-mb-0',
            mobileText && 'tw-hidden md:tw-flex'
          )}
          style={{ color: textHexColor || 'white' }}
          dangerouslySetInnerHTML={{ __html: desktopText }}
        />
      )}

      {mobileText && (
        <div
          className="tw-py-[5px] tw-flex tw-flex-col tw-items-center [&>*]:tw-m-0 md:tw-hidden tw-text-center tw-font-nav-link tw-font-normal tw-text-be-2xs lg:tw-text-be-s lg:tw-text-base group-hover:tw-no-underline !hover:tw-no-underline tw-mb-0"
          style={{ color: textHexColor || 'white' }}
          dangerouslySetInnerHTML={{ __html: mobileText }}
        />
      )}

      {(link || iconRight) &&
        (iconRight ? (
          <img
            src={iconRight}
            alt={iconRightAlt || ''}
            className="tw-max-w-full tw-max-h-full tw-m-0 tw-ml-2 !tw-w-5 md:!tw-w-6"
          />
        ) : (
          <i
            className="iconfont iconfont-right tw-m-0 tw-ml-2 tw-text-[10px]"
            style={{ color: textHexColor || 'white' }}
          />
        ))}
    </a>
  ) : (
    <div
      className={beTwMerge('tw-flex tw-justify-center tw-items-center tw-mb-0 tw-min-h-[39px] lg:tw-min-h-[32px]')}
      style={{ backgroundColor: backgroundHexColor || colors['dark-green'].raw }}
    >
      {iconLeft && (
        <div className="tw-m-0 tw-mr-2" style={{ color: textHexColor || 'white' }}>
          <img className="tw-max-w-full t-max-h-full !tw-w-5 md:!tw-w-6" src={iconLeft} alt={iconLeftAlt || ''} />
        </div>
      )}

      {desktopText && (
        <div
          className={beTwMerge(
            'tw-py-[5px] tw-flex tw-items-center [&>*]:tw-m-0 t-h-full tw tw-text-center tw-font-nav-link tw-font-normal tw-text-be-2xs lg:tw-text-be-s group-hover:tw-no-underline lg:tw-text-base !hover:tw-no-underline tw-mb-0',
            mobileText && 'tw-hidden md:tw-flex'
          )}
          style={{ color: textHexColor || 'white' }}
          dangerouslySetInnerHTML={{ __html: desktopText }}
        />
      )}

      {mobileText && (
        <div
          className="tw-py-[5px] tw-flex tw-flex-col tw-items-center [&>*]:tw-m-0 md:tw-hidden tw-text-center tw-font-nav-link tw-font-normal tw-text-be-2xs lg:tw-text-be-s group-hover:tw-no-underline !hover:tw-no-underline tw-mb-0"
          style={{ color: textHexColor || 'white' }}
          dangerouslySetInnerHTML={{ __html: mobileText }}
        />
      )}

      {(link || iconRight) &&
        (iconRight ? (
          <img
            src={iconRight}
            alt={iconRightAlt || ''}
            className="tw-max-w-full tw-max-h-full tw-m-0 tw-ml-2 !tw-w-5 md:!tw-w-6"
          />
        ) : (
          <i
            className="iconfont iconfont-right tw-m-0 tw-ml-2 tw-text-[10px]"
            style={{ color: textHexColor || 'white' }}
          />
        ))}
    </div>
  );
}
